 document.addEventListener('DOMContentLoaded', function () {
    const faqSections = document.querySelectorAll('.faq-section');

    faqSections.forEach(function (section) {
      const items = section.querySelectorAll('.faq-item');

      items.forEach(function (item) {
        const button = item.querySelector('.faq-item__question');
        const answer = item.querySelector('.faq-item__answer');

        button.addEventListener('click', function () {
          const isOpen = item.classList.contains('is-open');

          items.forEach(function (otherItem) {
            const otherButton = otherItem.querySelector('.faq-item__question');
            const otherAnswer = otherItem.querySelector('.faq-item__answer');

            otherItem.classList.remove('is-open');
            otherButton.setAttribute('aria-expanded', 'false');
            otherAnswer.hidden = true;
          });

          if (!isOpen) {
            item.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
            answer.hidden = false;
          }
        });
      });
    });
  });